<template>
  <default-layout>
    <h3 class="title is-3">Invite Admin</h3>
    <div class="subtitle">Send an invitation to become a Fit admin to the email address provided.</div>
    <form @submit.prevent="handleSubmit">
      <user-form @data="data = $event"></user-form>
      <button type="submit" class="button is-primary">Submit</button>
    </form>
  </default-layout>
</template>

<script>
import UserForm from '../components/users/UserForm.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'
import { sendUserInvite } from '../graphql/users'

export default {
  components: {
    DefaultLayout,
    UserForm
  },
  data () {
    return {
      data: null
    }
  },
  methods: {
    handleSubmit () {
      if (!this.data) {
        return
      }
      // run mutation
      this.$apollo.mutate({
        mutation: sendUserInvite,
        variables: {
          name: this.data.name,
          email: this.data.email,
          isAdmin: true
        }
      })
        .then(() => {
          this.$toast.open({
            message: 'Admin invitation sent to ' + this.data.email,
            type: 'is-success'
          })
          // redirect
          this.$router.push({ name: 'users' })
        })
        .catch((e) => {
          this.$toast.open({
            message: e.message || e,
            type: 'is-danger',
            duration: 5000
          })
        })
    }
  }
}
</script>
